import { filterNull } from '../../common/utils/filter-null';
import { DEFAULT_CONFIG } from '../constants';
import { BaseGraphQlClient } from '../graphql-client';
import { logException } from '../sentry/main';
const buildTeamHealthQuery = (teamId, cloudId) => ({
  query: `query TeamHealthMonitors($teamId: String!, $cloudId: String) {
    TeamHealthMonitors: teamHealthMonitorsByTeamId(teamId: $teamId, sort: CREATION_DATE_DESC, first: 5) {
      edges {
        node {
          creationDate
          isComplete(cloudId: $cloudId)
          uuid
          teamHealthMonitorResults(cloudId: $cloudId) {
            rating
          }
        }
      }
    }
  }`,
  variables: {
    teamId,
    cloudId
  }
});
const delay = millis => new Promise(resolve => {
  setTimeout(resolve, millis);
});
export class AtlasClient extends BaseGraphQlClient {
  constructor(baseUrl, config) {
    super(`${baseUrl}/watermelon/graphql`, config);
  }
  setBaseUrl(baseUrl) {
    this.setServiceUrl(`${baseUrl}/watermelon/graphql`);
  }
  canRetryError(pendingRetries, error) {
    return pendingRetries > 0 && !!error && typeof error === 'object' && 'category' in error && error.category === 'NotFound';
  }

  /**
   * Gets team health monitor data
   * @param {string} teamId
   * @returns {Promise}
   * @private
   */
  queryTeamHealthMonitors(teamId) {
    const teamHealthQuery = buildTeamHealthQuery(teamId, this.getContext().cloudId);
    const performRequest = async (pendingRetries = 3, backoffMaxDelay = 2000) => {
      try {
        var _data$TeamHealthMonit, _data$TeamHealthMonit2;
        const data = await this.makeGraphQLRequest(teamHealthQuery, {
          operationName: 'TeamHealthMonitors'
        });
        return (_data$TeamHealthMonit = (_data$TeamHealthMonit2 = data.TeamHealthMonitors.edges) === null || _data$TeamHealthMonit2 === void 0 ? void 0 : _data$TeamHealthMonit2.map(edge => {
          var _node$teamHealthMonit, _node$teamHealthMonit2, _node$teamHealthMonit3, _node$teamHealthMonit4, _node$teamHealthMonit5, _node$teamHealthMonit6;
          const node = edge === null || edge === void 0 ? void 0 : edge.node;
          if (!node || !node.uuid || !node.creationDate) {
            return null;
          }
          return {
            date: node.creationDate,
            uuid: node.uuid,
            greenCount: (_node$teamHealthMonit = (_node$teamHealthMonit2 = node.teamHealthMonitorResults) === null || _node$teamHealthMonit2 === void 0 ? void 0 : _node$teamHealthMonit2.filter(result => result.rating === 'GREEN').length) !== null && _node$teamHealthMonit !== void 0 ? _node$teamHealthMonit : 0,
            yellowCount: (_node$teamHealthMonit3 = (_node$teamHealthMonit4 = node.teamHealthMonitorResults) === null || _node$teamHealthMonit4 === void 0 ? void 0 : _node$teamHealthMonit4.filter(result => result.rating === 'YELLOW').length) !== null && _node$teamHealthMonit3 !== void 0 ? _node$teamHealthMonit3 : 0,
            redCount: (_node$teamHealthMonit5 = (_node$teamHealthMonit6 = node.teamHealthMonitorResults) === null || _node$teamHealthMonit6 === void 0 ? void 0 : _node$teamHealthMonit6.filter(result => result.rating === 'RED').length) !== null && _node$teamHealthMonit5 !== void 0 ? _node$teamHealthMonit5 : 0
          };
        }).filter(filterNull)) !== null && _data$TeamHealthMonit !== void 0 ? _data$TeamHealthMonit : [];
      } catch (error) {
        if (this.canRetryError(pendingRetries, error)) {
          await delay(backoffMaxDelay / pendingRetries);
          return performRequest(pendingRetries - 1);
        }
        throw error;
      }
    };
    return performRequest();
  }
}
export const atlasClient = new AtlasClient(DEFAULT_CONFIG.stargateRoot, {
  logException
});